import { Component, Inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ScreenType } from 'src/app/enums/ScreenType';
import { AumyeAuthenticationService } from 'src/app/services/aumye-authentication.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import {
  IAuthenticationState,
  initIAuthenticationState,
} from 'src/app/state-management/states/aumye-authentication.state';

@Component({
  selector: 'app-login-screen-dialog',
  templateUrl: './login-screen-dialog.component.html',
  styleUrls: ['./login-screen-dialog.component.scss'],
})
export class LoginScreenDialogComponent {
  commonData: IAuthenticationState = initIAuthenticationState;
  screenSize: ScreenType;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _formBuilder: FormBuilder,
    private authenticationService: AumyeAuthenticationService,
    private _screenSize: AumyeResponsiveScreenService,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) {
    this._screenSize.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
      if (screenData == ScreenType.Mobile) {
        // const deviceWidth = window.innerWidth + 'px';
        // document.documentElement.style.setProperty(
        //   '--device-width',
        //   deviceWidth
        // );
        const tabFontSize = 14 + 'px';
        document.documentElement.style.setProperty(
          '--font-size-tab',
          tabFontSize
        );
      }
    });
  }
  selectedOption: string;
  tabIndex = 0;
  hide = true;
  flag = false;
  statusOptions: string[] = ['Open', 'Close', 'Verified'];
  adminFormGroup = this._formBuilder.group({
    AccountID: ['', [Validators.required, Validators.pattern('^[0-9]{8}$')]],
    PIN: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]],
  });
  userFormGroup = this._formBuilder.group({
    Password: ['', [Validators.required]],
    Email: ['', [Validators.required, Validators.email]],
  });
  onChangeTab(event: any) {
    this.tabIndex = event.index;
    if (this.tabIndex == 0) this.adminFormGroup.reset();
    if (this.tabIndex == 1) this.userFormGroup.reset();
    this.commonData.login.errorMessage = null;
  }
  inputValidator(event: { charCode: number }) {
    return (
      (event.charCode != 8 && event.charCode == 0) ||
      (event.charCode >= 48 && event.charCode <= 57)
    );
  }
  onLogin() {
    this.commonData.status.isError = false;
    this.commonData.login.errorMessage = null;
    this.commonData.status.isFetchingAPIRequest = true;
    const userCreds = {
      // LoginType: number, //0 - admin,1- others
      loginType: this.tabIndex,
      accountID: this.adminFormGroup.value.AccountID,
      accountPIN: this.adminFormGroup.value.PIN,
      username: 'this.userFormGroup.value.Username',
      userEmail: this.userFormGroup.value.Email,
      userPassword: this.userFormGroup.value.Password,
    };

    this.authenticationService
      .onLogin({
        LoginType: userCreds.loginType,
        accountID: userCreds.accountID,
        accountPIN: userCreds.accountPIN,
        username: userCreds.username,
        userEmail: userCreds.userEmail,
        userPassword: userCreds.userPassword,
      })
      .subscribe(
        (res) => {
          this.commonData.status.isFetchingAPIRequest = false;
          if (
            res.userDetail.userID == this.data.hostUserId ||
            res.userDetail.userID == this.data.userId
          ) {
            localStorage.setItem(
              'OrganizationId',
              res.userDetail.organizationID
            );
            localStorage.setItem('UserEmail', res.userDetail.email);
            localStorage.setItem('UserId', res.userDetail.userID);
            localStorage.setItem(
              'FullName',
              res.userDetail.firstName + ' ' + res.userDetail.lastName
            );
            localStorage.setItem('Role', res.userDetail.role);
            localStorage.setItem('ProfilePic', res.userDetail.profilePic);
            localStorage.setItem('AumyeId', res.userDetail.AumyeId);
            localStorage.setItem('Aumye', res.userDetail.Aumye);
            this.dialog.closeAll();
            // //this.toastr.success('Login Success');
          } else {
            this.commonData.status.isError = true;
            this.commonData.login.errorMessage = 'User Invalid';
            this.toastr.error('Login Failed');
          }
        },
        (err) => {
          this.commonData.status.isFetchingAPIRequest = false;
          this.commonData.status.isError = true;
          this.commonData.login.errorMessage = err.global;
          this.toastr.error('Login Failed');
        }
      );
  }
  ScreenType = ScreenType;
}
